// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","resumePhoneList":"_3eGw0yP2lcevnerWv0O__R","viewResumeLink":"_2TsL7w7Hw3LMJJETJAKv6r"};